import React from 'react'
import {
    Row, Col, FormikRadioGroup, FormikInput,
    FormikTextArea, FormikCheckbox, FormikSelect, FormikDate
} from '../../../Elements/'
import { GeneralComments } from './JobDetailForm'

export const PresiteDateAndSupervisorColumns = ({ namePrefix, supervisorList = [], wide = false }) => {
    const mdLgSize = wide ? 4 : 2
    return <>
        <Col xs={12} sm={12} med={mdLgSize} lg={mdLgSize}>
            <FormikDate
                label='Presite Date'
                name={`${namePrefix}.checkin_date`}
            />
        </Col>
        <Col xs={12} sm={12} med={mdLgSize} lg={mdLgSize}>
            <FormikDate
                label='Scheduled Date'
                name={`${namePrefix}.scheduled_date`}
            />
        </Col>
        <Col xs={12} sm={12} med={mdLgSize} lg={mdLgSize}>
            <FormikSelect
                nullable
                label='Supervisor'
                items={supervisorList}
                name={`${namePrefix}.presite_supervisor`}
            />
        </Col>
    </>
}

//#region styles
const quarterWidthStyle = {
    maxWidth: '25%',
    display: 'inline-block',
    marginRight: '5%'
}

const thirdWidthStyle = {
    maxWidth: '20%',
    display: 'inline-block',
    margin: '0 5% 5% 5%'
}

const radioListStyle = {
    maxWidth: '100%',
    display: 'inline-block',
    margin: 0
}

const otherStyle = {
    maxWidth: '40%',
    display: 'inline-block',
    margin: 0
}

const halfWidthStyle = {
    maxWidth: '50%',
    display: 'inline-block',
    marginRight: '5%'
}

//#endregion styles

export const PresiteGuniteFieldsRow = ({ namePrefix, values }) => {
    return <Row>
        <Col xs={12} sm={12} med={6} lg={6}>
            <FormikInput
                min='0'
                type='number'
                label='Feet of Hose Needed'
                name={`${namePrefix}.feet_of_hose_needed`}
                groupStyles={quarterWidthStyle}
            />
            <FormikCheckbox
                label='Water On Site'
                name={`${namePrefix}.is_water_on_site`}
                checked={values.presite.is_water_on_site}
            />
            <FormikCheckbox
                label='Access To Power'
                name={`${namePrefix}.is_access_to_power`}
                checked={values.presite.is_access_to_power}
            />
            <FormikCheckbox
                label='Pool Ready To Shoot'
                name={`${namePrefix}.is_pool_ready_to_shoot`}
                checked={values.presite.is_pool_ready_to_shoot}
            />
            <FormikCheckbox
                label='Job Caved In'
                name={`${namePrefix}.is_job_caved_in`}
                checked={values.presite.is_job_caved_in}
            />
            <FormikCheckbox
                label='Stub Out'
                name={`${namePrefix}.is_stub_out`}
                checked={values.presite.is_stub_out}
            />
            <FormikCheckbox
                label='Needs Inspection'
                name={`${namePrefix}.is_needs_inspection`}
                checked={values.presite.is_needs_inspection}
            />
            <FormikTextArea
                label='Access Notes'
                name={`${namePrefix}.access_notes`}
            />
        </Col>
        <Col xs={12} sm={12} med={6} lg={6}>
            <FormikCheckbox
                label='Steel Done'
                name={`${namePrefix}.is_steel_done`}
                checked={values.presite.is_steel_done}
            />
            <FormikTextArea
                label='Steel Notes'
                name={`${namePrefix}.steel_notes`}
            />
            <FormikCheckbox
                label='Depth Matches Plan'
                name={`${namePrefix}.is_depth_matches_plan`}
                checked={values.presite.is_depth_matches_plan}
            />
            <FormikTextArea
                label='Additional Depth Notes'
                name={`${namePrefix}.additional_depth_notes`}
            />
            <FormikTextArea
                label='Plan Change Notes'
                name={`${namePrefix}.plan_change_notes`}
            />
        </Col>
    </Row>
}

export const PresitePebbleFieldsRows = ({ namePrefix, values, jobDetailId, slurryTypes = [], vgbMainDrainsBy = [] }) => {
    return <>
        <Row>
            <Col xs={12} sm={12} med={6} lg={6}>
                <FormikRadioGroup
                    name={`${namePrefix}.slurry_type`}
                    label="Slurry MMG:"
                    items={slurryTypes}
                    inline={true}
                    groupStyles={radioListStyle}
                    dependantNames={[`${namePrefix}.slurry_type_other`]}
                />
                {values?.presite?.slurry_type?.name === 'Other' &&
                    <FormikInput
                        type='text'
                        name={`${namePrefix}.slurry_type_other`}
                        placeholder='Other'
                        groupStyles={otherStyle} />
                }
                <FormikTextArea
                    name={`${namePrefix}.slurry_type_notes`}
                    label='Slurry Notes'
                />
                <p>Fittings:</p>
                <FormikInput
                    groupStyles={thirdWidthStyle}
                    name={`${namePrefix}.fittings_pool`}
                    placeholder='Pool'
                    min='0'
                    label='Pool'
                />
                <FormikInput
                    groupStyles={thirdWidthStyle}
                    name={`${namePrefix}.fittings_spa`}
                    placeholder='Spa'
                    label='Spa'
                />
                <FormikInput
                    groupStyles={thirdWidthStyle}
                    name={`${namePrefix}.fittings_other`}
                    placeholder='Other'
                    min='0'
                    label='Other'
                />
                <p>Eyeballs:</p>
                <FormikInput
                    groupStyles={thirdWidthStyle}
                    name={`${namePrefix}.eyeballs_pool`}
                    placeholder='Pool'
                    min='0'
                    label='Pool'
                />
                <FormikInput
                    groupStyles={thirdWidthStyle}
                    name={`${namePrefix}.eyeballs_spa`}
                    placeholder='Spa'
                    min='0'
                    label='Spa'
                />
                <FormikInput
                    groupStyles={thirdWidthStyle}
                    name={`${namePrefix}.eyeballs_slotted`}
                    placeholder='Slotted'
                    min='0'
                    label='Slotted'
                />
            </Col>
            <Col xs={12} sm={12} med={6} lg={6}>
                <FormikInput
                    type='number'
                    label='Rope Anchors'
                    name={`${namePrefix}.rope_anchors`}
                    groupStyles={quarterWidthStyle}
                    min='0'
                />
                <FormikInput
                    type='number'
                    label='Umbrella Sleeves'
                    name={`${namePrefix}.umbrella_sleeves`}
                    groupStyles={quarterWidthStyle}
                    min='0'
                />
                <FormikInput
                    type='number'
                    label='In-floor Nozzles'
                    name={`${namePrefix}.in_floor_nozzles`}
                    groupStyles={quarterWidthStyle}
                    min='0'
                />

                <FormikInput
                    label='10# VGB Main Drains'
                    name={`${namePrefix}.vgb_main_drains`}
                    min='0'
                    groupStyles={quarterWidthStyle}
                />
                <FormikRadioGroup
                    name={`${namePrefix}.vgb_main_drains_by`}
                    items={vgbMainDrainsBy}
                    inline={true}
                    groupStyles={radioListStyle}
                />
                <FormikInput
                    type='number'
                    label='Estimated Number of Batches'
                    name={`${namePrefix}.estimated_number_of_batches`}
                    groupStyles={halfWidthStyle}
                    min='0'
                />
                <FormikInput
                    type='number'
                    label='Estimated Number of Hoses'
                    name={`${namePrefix}.estimated_number_of_hoses`}
                    groupStyles={halfWidthStyle}
                    min='0'
                />
                <FormikCheckbox
                    name={`${namePrefix}.install_trim_tile_mosaics`}
                    checked={values.presite.install_trim_tile_mosaics}
                    label='Install Trim Tile/Mosaics'
                />
                <FormikCheckbox
                    name={`${namePrefix}.is_bond_cote`}
                    checked={values.presite.is_bond_cote}
                    label='Bond Cote'
                />
                <FormikCheckbox
                    name={`${namePrefix}.is_complete_chip_out`}
                    checked={values.presite.is_complete_chip_out}
                    label='Complete Chip Out'
                />
                <FormikCheckbox
                    name={`${namePrefix}.is_weeping`}
                    checked={values.presite.is_weeping}
                    label='Weeping'
                />
            </Col>
        </Row>
        <Row>
            <Col lg={12}>
                <GeneralComments
                    isPresite
                    jobDetailId={jobDetailId}
                    name={`${namePrefix}.comments`}
                    generalComments={values.presite.comments}
                />
            </Col>
        </Row>
    </>
}